import axios from "axios";
import Cinema from "../../../models/cinema_model";
import { apiEndpoint } from "../../../routes/api_endpoints";
import { API_KEY } from "../../../utilities/apiKey";
//get cinemas from api

const getCinemas = (City = "NAIROBI") =>
  new Promise((resolve, reject) => {
    axios
      .post(
        apiEndpoint,
        {
          RequestID: "GETMOVIEPROVIDERS",
          SessionID: "HBhGpLw0efgwbDqILlYSCC9WT5hoo=4oCh",
          Country: "KENYA",
          City: City.toUpperCase(),
          UserID: "Pesapal",
          Key: "2344",
          MobileNumber: "254700928129",
          TrxReference: "123487",
          IMEI: "231766434532535",
        },
        {
          headers: {
            "X-API-KEY": API_KEY,
          },
        }
      )
      .then((response) => {
        resolve(response.data.map((cinema) => new Cinema({ ...cinema })));
      })
      .catch((error) => reject(error));
  });

export default getCinemas;
